import { Injectable } from "@angular/core";
import { BaseSubmenuAppVarsService } from "../../submenu-left-tabs/ng-submenu-app-vars/base-submenu-app-vars.service";
import { BaseAppDetailEnvService } from "../../base-app-detail-env.service";

@Injectable()
export class BaseSubmenuEngVarsService extends BaseSubmenuAppVarsService {
    constructor (envCtrlSvc: BaseAppDetailEnvService) {
        super(envCtrlSvc);
    }
}
